<template>
<div class="home-category-content">
  <SectionHeadingLarge heading="Browse by Category" />
  <ul class="inline-list">
    <li class="inline-list-item" :key="category.id" v-for="category in categories">
      <router-link :id="category.id" :to="category.target">{{category.name}}</router-link>
    </li>
  </ul>
</div>
</template>

<script>
import { categories } from '../../data/config.json';
import SectionHeadingLarge from '../SectionHeadingLarge/SectionHeadingLarge';

export default {
  name: 'Categories',
  components: {
    SectionHeadingLarge
  },
  data() {
    return {
      categories
    };
  }
};
</script>

<style lang="scss" scoped>

.home-category-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 150px 50px;

  @media (max-width: 568px) {
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .inline-list-item {
    text-align: center;

    a {

      @media (max-width: 568px) {
        padding-top: 5px;
        padding-bottom: 5px;
        display: block;
      }
    }
  }
}

.inline-list {
  padding-top: 10px;
}
</style>
